import React from 'react';
import { HyperdbForm } from '../../../../hyperdb';
import { Form } from '../components';

export default HyperdbForm(Form, {
  namespace: 'reservation',
  mountedUrl: '/daily-rental/reservations',
  titleNew: 'Create new reservation',
  titleEdit: 'Edit reservation',
  displayName: (object) => object.reference,
  checkIsValid: (props) => {
    const hasRelations = props.objectData.property && props.objectData.property.value[1] && props.objectData.customer && props.objectData.customer.value[1];
    return hasRelations && !!props.objectData.origin && !!props.objectData.creation_date && !!props.objectData.arrival_date && !!props.objectData.departure_date;
  },
});



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/reservation/containers/Form.jsx